import { render } from "./ElemEmpr.vue?vue&type=template&id=5b3f9b52&scoped=true"
import script from "./ElemEmpr.vue?vue&type=script&lang=js"
export * from "./ElemEmpr.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada02.css?vue&type=style&index=0&id=5b3f9b52&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=5b3f9b52&scoped=true&lang=css"
import "./ElemEmpr.vue?vue&type=style&index=2&id=5b3f9b52&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3f9b52"]])

export default __exports__